/**
 * @JSdoc Object
 * @name constants.js
 * @description
 */

 function gHasValue(variable) {
    return (typeof variable !== 'undefined' && variable !== null && variable !== '');
  }
  
  export default {
    Context: {
      APP: null,
      STORE: null,
      TRANSLATE: null,
    },

    Lang: [
      {
        value: 'en',
        i18n: 'lang.english'
      },
      {
        value: 'es',
        i18n: 'lang.spanish'
      }
    ],
  
    Date: {
      FORMAT: 'lll',
      DATE: 'MMMM Do YYYY',
      HOUR: 'h:mm a',
      SHORT_DATE: 'lll',
    },

    Security: {
        Action : {
            VIEW_USERS: 'VIEW_USERS',
            CREATE_USER: 'CREATE_USER',
            UPDATE_USER: 'UPDATE_USER',
            DELETE_USER: 'DELETE_USER',
            VIEW_CUSTOMERS: 'VIEW_CUSTOMERS',
            VIEW_LOT_TAB: 'VIEW_LOT_TAB',
            CREATE_LOT: 'CREATE_LOT',
            UPDATE_LOT: 'UPDATE_LOT',
            EDIT_RESERVED_LOT: 'EDIT_RESERVED_LOT',
            DELETE_LOT: 'DELETE_LOT',
            VIEW_RESERVATION_TAB: 'VIEW_RESERVATION_TAB',
            CREATE_RESERVATION: 'CREATE_RESERVATION',
            EDIT_RESERVATION: 'EDIT_RESERVATION',
            CANCEL_RESERVATION: 'CANCEL_RESERVATION',
            APPROVE_RESERVATION: 'APPROVE_RESERVATION',
            VIEW_LOG: 'VIEW_LOG',
            VIEW_AGENTS: 'VIEW_AGENTS',
            CREATE_AGENT: 'CREATE_AGENT',
            UPDATE_AGENT: 'UPDATE_AGENT',
            DELETE_AGENT: 'DELETE_AGENT',
            VIEW_REPORT: 'VIEW_REPORT',
            VIEW_INVENTORY_REPORT: 'VIEW_INVENTORY_REPORT',
            VIEW_SALES_REPORT: 'VIEW_SALES_REPORT',
            VIEW_VISITS_REPORT: 'VIEW_VISITS_REPORT',
            VIEW_HEAT_REPORT: 'VIEW_HEAT_REPORT',
        }
    },

    UserType: {
        ADMIN: 1,
        OPERATIONS: 2,
        DEV_ADMIN: 3,
        DEV_SELLER: 4,
        CUSTOMER: 5,
        DEV_REAL_STATE: 6,
    },

    UserGroup: {
        DECKGL: 'DECKGL',
        DEVELOPER: 'DEVELOPER',
        CUSTOMER: 'CUSTOMER',
    }
    
  };
  